module.exports = __webpack_public_path__ + "img/cww_02.b5f933ab.jpg";